import { Injectable } from '@angular/core';
import { ApiService } from './Api.service';

@Injectable({
  providedIn: 'root'
})
export class CoursesService {

  coursesUrl = 'public/courses';
  baseDataUrl = 'data';
  lessonStatusUrl = 'lesson_status';
  coursesListUrl = 'public/list/courses';
  contactUrl = 'contact';
  subscribeUrl = 'subscription';
  reviewUrl = 'review';
  finishedCoursesUrl = 'public/list/finished';

  constructor(private apiService: ApiService) {
  }


  async getCourses() {
    try {
      const courses = await this.apiService.get(this.coursesUrl + '?status=pending');
      return courses;
    } catch (error) {
      return error;
    }
  }

  async getExtras() {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const extras = await this.apiService.get('users/' + user.id + '/extras');
      return extras;
    } catch (error) {
      return error;
    }
  }

  async getCourseById(courseId) {
    try {
      const course = await this.apiService.get(this.coursesUrl.concat('/').concat(courseId));
      return course;
    } catch (error) {
      return error;
    }
  }

  async getVideoData(videoUri) {
    try {
      const videoData = await this.apiService.get(this.baseDataUrl.concat(videoUri));
      return videoData;
    } catch (error) {
      return error;
    }
  }

  async changeLessonStatus(status, lessonId,courseId) {
    try {
      const data = {
        course: courseId,
        lesson: lessonId,
        status
      }
      const videoData = await this.apiService.post(this.lessonStatusUrl, data);
      return videoData;
    } catch (error) {
      return error;
    }
  }

  async getPublicList(page = 1,first=1, last=21,status='') {
    try {
      let r_stats='';
      if (status!=''){
        r_stats='&status='+status;
      }
      const courses = await this.apiService.get(this.coursesListUrl.concat('?page=' + page+'&level_from='+first+'&level_to='+last+r_stats));
      return courses;
    } catch (error) {
      return error;
    }
  }

  async getPendingList(page = 1) {
    try {
      const courses = await this.apiService.get(this.coursesListUrl.concat('?page=' + page + '&status=pending'));
      return courses;
    } catch (error) {
      return error;
    }
  }

  async sendContactForm(values) {
    try {
      await this.apiService.post(this.contactUrl, values);
      return true;
    } catch (error) {
      return error;
    }
  }

  async subscribeToActiveCampaign(email) {
    try {
      const response = await this.apiService.post(this.subscribeUrl, email);
      return response;
    } catch (error) {
      return error;
    }
  }


  public getSubscriptionHeaders(): {} {
    const headers = {};
    headers['Api-Token'] = 'dac882db85b93567fed982e67d4a64c9a527fc516fda33776a3ab05dca63f8abdebd8405';
    headers['Content-']
    return headers;
  }


  sendCustomSubscription() {

  }

 async sendCourseReview(review) {
    try {
      const response = await this.apiService.post(this.reviewUrl, review);
      return response;
    } catch (error) {
      return error;
    }
  }


  async getAllFinishedCourses(page = 1) {
    try {
      const courses = await this.apiService.get(this.finishedCoursesUrl.concat('?page=' + page));
      return courses;
    } catch (error) {
      return error;
    }
  }


}
